import API_BASE_URL from '../Config';

const API_URL = `${API_BASE_URL}/formas-pago`;

export const getFormasPago = async (token) => {
    const response = await fetch(API_URL, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar formas de pago');
    return response.json();
};

export const getFormasPagoPaginadas = async (token, page = 0, size = 10, search = '') => {
    const response = await fetch(`${API_URL}/page?page=${page}&size=${size}&search=${search}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar formas de pago paginadas');
    return response.json();
};

export const getFormaPagoById = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al obtener la forma de pago');
    return response.json();
};

export const createFormaPago = async (token, data) => {
    const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear forma de pago');
    return response.json();
};

export const updateFormaPago = async (token, id, data) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar forma de pago');
    return response.json();
};

export const deleteFormaPago = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar forma de pago');
    return true;
};
